import { FormattedMessage } from 'react-intl';
import { addMethod, setLocale, string } from 'yup';

import { containsURL } from '@/shared/lib';

declare module 'yup' {
  interface StringSchema {
    noURL(message?: string): this;
  }

  interface StringLocale {
    noURL?: () => JSX.Element;
  }
}

setLocale({
  string: {
    min: ({ min }: { min: number }) => (
      <FormattedMessage
        id="yup.min"
        defaultMessage="Must be at least {min} characters"
        values={{ min }}
      />
    ),
    max: ({ max }: { max: number }) => (
      <FormattedMessage
        id="yup.max"
        defaultMessage="Must be at most {max} characters"
        values={{ max }}
      />
    ),
    email: () => (
      <FormattedMessage id="yup.email" defaultMessage="Incorrect email" />
    ),
    url: () => (
      <FormattedMessage id="yup.url" defaultMessage="Must be a valid URL" />
    ),
    trim: () => (
      <FormattedMessage
        id="yup.trim"
        defaultMessage="Must be a trimmed string"
      />
    ),
    noURL: () => (
      <FormattedMessage
        id="yup.noURL"
        defaultMessage="URLs and links are not allowed in this field"
      />
    ),
  } as Record<string, unknown>,
  mixed: {
    required: () => (
      <FormattedMessage id="yup.required" defaultMessage="Field is required" />
    ),
    oneOf: () => (
      <FormattedMessage id="global.required" defaultMessage="Required" />
    ),
  },
});

addMethod(string, 'noURL', function (message) {
  return this.test('no-url', message, function (value) {
    const { path, createError } = this;

    if (!value) {
      return true;
    }

    if (containsURL(value)) {
      return createError({
        path,
        message: message || 'URLs are not allowed in this field',
      });
    }

    return true;
  });
});

// eslint-disable-next-line react-refresh/only-export-components
export * from 'yup';
